import React, { useState, useEffect } from "react";
import { Row, Col, Popover, Input, Divider, Tag } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import FilterTag from "./FilterTag";
import {
  FilterDropdownContainer,
  FilterSearchBox,
  FilterWrapper,
} from "./styled";
import { FiFilter } from "react-icons/fi";
// import { uid } from "uid";

const Filter = ({ show, setShow, data }) => {
  const [searchText, setSearchText] = useState("");
  //   const severityColor = useSelector(makeSelectSeverityColor());
  return (
    <FilterWrapper>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <div>
          <Popover
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            placement="topLeft"
            // open={show}
            // onVisibleChange={(e) => setShow(e)}
            title={null}
            content={
              <div>
                <FilterSearchBox>
                  <Input
                    placeholder="Search..."
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </FilterSearchBox>
                <FilterDropdownContainer>
                  <div className="filter-container">
                    <Row style={{ height: "142px", overflow: "auto" }}>
                    {data?.map((dataItem, index) => (
                      <span key={index}>
                        <div className="row-flex justify-content-between text-primary">
                          <span className="font-12 font-semibold">{dataItem?.title}</span>
                        </div>
                        <div className="row-flex" style={{ flexWrap: "wrap" }}>
                          {dataItem?.list
                            ?.filter(
                              (fil) =>
                                !dataItem?.filterList?.includes(fil) &&
                                (fil?.toLowerCase() || "")
                                  .includes((searchText || "").toLowerCase())
                            )
                            ?.map((item) => {
                              // Check if this filter has tag colors configured
                              if (dataItem?.tagColors && dataItem?.tagColors[item]) {
                                const tagConfig = dataItem?.tagColors[item];
                                return (
                                  <Tag
                                    key={item}
                                    color={tagConfig.color}
                                    style={{
                                      margin: "4px",
                                      cursor: "pointer",
                                      fontWeight: 500,
                                      padding: "4px 8px",
                                      borderRadius: "4px",
                                    }}
                                    onClick={() => {
                                      dataItem?.setFilterList([
                                        ...dataItem?.filterList,
                                        item,
                                      ]);
                                    }}
                                  >
                                    {tagConfig.label || item}
                                  </Tag>
                                );
                              }
                              // Default FilterTag for non-colored filters
                              return (
                                <FilterTag
                                  key={item}
                                  background={"var(--border-color)"}
                                  color={"var(--primary-text-color)"}
                                  onClick={() => {
                                    dataItem?.setFilterList([
                                      ...dataItem?.filterList,
                                      item,
                                    ]);
                                  }}
                                  item={item}
                                />
                              );
                            })}
                        </div>
                        <div className="">
                          {dataItem?.list?.filter(
                            (fil) =>
                              !dataItem?.filterList?.includes(fil) &&
                              (fil?.toLowerCase() || "")
                                .includes((searchText || "").toLowerCase())
                          )?.length ? (
                            ""
                          ) : (
                            <span style={{ fontSize: "10px" }}>Not Found</span>
                          )}
                        </div>
                        <Divider
                          style={{
                            marginTop: 10,
                            marginBottom: 10,
                            background: "var(--border-color)",
                          }}
                        />
                      </span>
                    ))}
                    </Row>
                  </div>
                </FilterDropdownContainer>
              </div>
            }
            trigger="click"
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <div
                className="d-flex justify-content-center cursor"
                style={{
                  border: "1px solid var(--border-color)",
                  padding: "4px 13px",
                  borderRadius: "7px",
                  gap: "5px",
                  height: "42px",
                }}
                onClick={() => setShow(!show)}
              >
                <FiFilter color="var(--primary-text-color)" size={18} />
                <span className="font-17 text-primary font-semibold">
                  Filter
                </span>
              </div>
            </div>
          </Popover>
        </div>
        <div style={{ display: "flex" }}>
          {data?.map((dataItem) =>
            dataItem?.filterList?.map((item, index) => {
              // Check if this filter has tag colors configured
              if (dataItem?.tagColors && dataItem?.tagColors[item]) {
                const tagConfig = dataItem?.tagColors[item];
                return (
                  <div key={`${dataItem?.title}-${item}-${index}`}>
                    <Tag
                      color={tagConfig.color}
                      closable
                      style={{
                        margin: "4px",
                        fontWeight: 500,
                        padding: "4px 8px",
                        borderRadius: "4px",
                      }}
                      onClose={() => {
                        dataItem?.setFilterList(
                          dataItem?.filterList?.filter((fil) => fil !== item)
                        );
                      }}
                    >
                      {tagConfig.label || item}
                    </Tag>
                  </div>
                );
              }
              // Default FilterTag for non-colored filters
              return (
                <div key={`${dataItem?.title}-${item}-${index}`}>
                  <FilterTag
                    background={"var(--border-color)"}
                    color={"var(--primary-text-color)"}
                    onClick={() => {
                      dataItem?.setFilterList(
                        dataItem?.filterList?.filter((fil) => fil !== item)
                      );
                    }}
                    item={item}
                    closIcon={
                      <CloseCircleOutlined
                        style={{
                          color: "var(--primary-text-color)",
                          fontSize: "10px",
                          cursor: "pointer",
                        }}
                        className="ml-5"
                      />
                    }
                  />
                </div>
              );
            })
          )}
        </div>
      </div>
    </FilterWrapper>
  );
};

export default Filter;
